export const form = {
  headerTitle: 'CONVIÉRTETE EN DISTRIBUIDOR DE RIFFEL',
  formTitle: 'Complete la información a continuación para que podamos ayudarle',
  resultTitle:
    'A continuación encontrará información sobre nuestros distribuidores.',
  name: 'Razón social',
  name_placeholder: 'Introduzca el nombre de la empresa',
  cnpj: 'CNPJ',
  cnpj_placeholder: 'Introduce tu CNPJ',
  invalid_feedback_cnpj: 'CNPJ no válido',
  responsible: 'Responsable',
  responsible_placeholder: 'Introduzca el nombre del responsable de la empresa',
  companyType: '¿Qué tipo de empresa es?',
  monthlyRevenueAverage: '¿Cuál es el promedio de ventas mensuales de su empresa?',
  segments: '¿Qué segmento? (seleccione más de uno si es necesario)',
  products:
    '¿Cuál es el producto de interés? (seleccione más de uno si es necesario)',
  kits: '¿Cuántos kits de transmisión/tracción venden al mes?',
  already_buy_from: '¿Ya compra Riffel?',
  buy_from: '¿De quién?',
  services:
    '¿Cómo prefieres que te atiendan? (seleccione más de uno si es necesario)',
  email: 'E-mail',
  email_placeholder: 'Escribe tu correo electrónico',
  phone: 'WhatsApp',
  phone_placeholder: 'Introduce tu número de WhatsApp',
  state: 'Estado',
  city: 'Ciudad',
  city_placeholder: 'Entra a la ciudad',
  zipcode: 'Código postal',
  zipcode_placeholder: 'Ingrese el código postal',
  uf: 'UF',
  invalid_feedback: '*Campo obligatorio',
  button: ' Enviar información',
};

export const optionsTexts = {
  defaultOption: "Seleccione una opción",
  companyType: {
    MEI: "MEI",
    ME: "ME",
    EPP: "EPP",
    LTDA: "LTDA",
    SA: "S/A",
  },
  kits: {
    upTo100: "Hasta 100",
    from100To300: "De 100 a 300",
    from300To1000: "De 300 a 1000",
    moreThan1000: "Más de 1000",
  },
  monthlyRevenue: {
    upTo20: "Hasta R$ 20 mil",
    from20To50: "De R$ 20 mil a R$ 50 mil",
    from50To100: "De R$ 50 mil a R$ 100 mil",
    from100To500: "De R$ 100 mil a R$ 500 mil",
    above500: "Más de R$ 500 mil",
  },
  segments: {
    workshop: "Taller",
    ecommerce: "Ecommerce",
    marketplace: "Marketplace",
    retailMotorcycleParts: "Venta minorista - Tienda de repuestos para motos",
    retailMotorcyclePartsWorkshop: "Venta minorista - Repuestos y taller",
    wholesaler: "Mayorista",
    others: "Otros (no relacionado con repuestos de motos)",
  },
  products: {
    kitTitanium: "Kit Titanium (sin retén)",
    kitTop: "Kit Top (con retén)",
    horn: "Bocina",
    timingChain: "Cadena de mando",
    kickStarter: "Pedal de arranque",
    steeringBox: "Caja de dirección",
    semiKit: "Semi Kit Riffel Carbon",
    timingChainTensionerRatchet: "Accionador del tensor de la cadena de mando",
    bearings: "Rodamientos",
    driveChain:
      "Cadena de transmisión Riffel Carbon (para motos de alta cilindrada)",
  },
  services: {
    phone: "Teléfono",
    whatsapp: "WhatsApp",
    email: "Correo electrónico",
  },
  buyFrom: {
    yes: "Sí",
    no: "No",
  },
}

export const result = {
  headerTitleResult: 'Gracias por las informaciones',
  hello: "Hola",
  manualReceived: "Su registro ha sido recibido con éxito.",
  manualInstruction:
    "A continuación encontrará el distribuidor más cercano para que pueda contactarlo directamente.",
  thanksInterest:
    "Agradecemos su interés en revender nuestros productos.",
  registrationReceived: "Su registro ha sido recibido con éxito.",
  riffelSoon:
    "Pronto será atendido por nuestro equipo comercial.",
  distributorSoon:
    "Pronto uno de nuestros distribuidores asociados se pondrá en contacto para realizar su atención.",
  stayAlert: "¡Mantente atento!",
  slogan: "Llega más lejos. Ve con Riffel.",
  cardReseller: {
    email: "Correo electrónico",
    phone: "Teléfono",
    whatsapp: "WhatsApp",
    address: "Dirección",
    city: "Ciudad",
    zipcode: "Código Postal",
    call: "Llamar",
  }
};
